import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import "../assets/stylesheets/EngagementReport.scss";
import Breadcrumb from "../components/Breadcrumb";
import List from "../components/List";

import DropdownSchool from './DropdownSchool';
import DropdownClass from './DropdownClass';

@inject('Navigator', 'StudentStore', 'ConfigStore', 'SchoolStore','AuthStore')
@observer
export default class EngagementReport extends Component {

    static breadcrumbSegments = [
        {
            title: "Portal do professor",
            uri: "/"
        },
        {
            title: "Engagement Report",
            uri: ""
        }
    ];


    constructor(props) {
        super(props);
        this.state = {
            classId: -1,
            name: ''
        }
    }

    componentWillMount(){
        if(this.props.SchoolStore.isSearch){ 
            // Solicitado que as combos permanecam cos os valores quando alterna de uma pagina para outra
            // this.props.SchoolStore.students = [];
            // this.props.SchoolStore.studentsEngagement = [];
            // this.props.SchoolStore.schoolSelected   = null;
            //this.props.SchoolStore.classSelected   = null;
            //this.props.SchoolStore.lessonSelected  = null;
            this.props.SchoolStore.isSearch = false;
        }
    }

    handleBreadcrumbClick(uri) {

        this.props.ConfigStore.animationType = "right";
        this.props.Navigator.push(uri);
    }

    handleClickStudent(studentId) {
        this.props.Navigator.push(`/engagement-student/${studentId}`);
    }

    handleChangeClass(e) {
        this.isLoading = true;
    }

    handleChangeSchool(e) {
        this.isLoading = true;
    }

    handleChangeLevel(e) {
        this.isLoading = true;
    }

    render() {

        let list = [];

        let students = this.props.SchoolStore.studentsEngagement;

        list = students.map(
            student => {
                return (
                    <div className="student" key={student.id} onClick={this.handleClickStudent.bind(this,student.id)}>
                        <div className="infos">
                            <div className="name">{student.firstName || student.firstName} {student.lastName}</div>
                        </div>
                    </div>
                )
            }
        );

        return (
            <div className="EngagementReport Page">
                <div className="container">
                    <div className="header-section">
                        <h1>Engagement Report</h1>
                        
                        <Breadcrumb segments={EngagementReport.breadcrumbSegments}
                                onClick={this.handleBreadcrumbClick.bind(this)}/>
                        
                    </div>
                    <div className="dropdowns">
                        <div className="DropdownFilter">

                            <DropdownSchool />

                            <DropdownClass isEngagement={true}/>

                        </div>
                    </div>
                    <div className="contents">
                        <div className="Map">
                            <List counter={list.length}
                                  messageEmpty={'Please select a school and group to list students'}
                                  loader={this.props.SchoolStore.isLoading}>
                                {list}
                            </List>
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./src/containers/EngagementReport.js